module.exports = "/public/assets/img/white-transparent-tick.svg";